import script from "./groupRules.vue?vue&type=script&setup=true&lang=js"
export * from "./groupRules.vue?vue&type=script&setup=true&lang=js"

import "./groupRules.vue?vue&type=style&index=0&id=7e72ce6d&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e72ce6d"]])

export default __exports__